function toggleModalOnClick(el, e){
  e.stopPropagation()
  el.classList.toggle('hidden-modal');
  console.log("showing")
  closeModalOnRandomClick(!el.classList.contains('hidden-modal'), el, e)
}

function closeModalOnRandomClick(isOpen, el){
  if(isOpen) {
    document.body.addEventListener('click', function(e){
      e.stopPropagation()
      console.log("removing")
      el.classList.add('hidden-modal');
    }, {once: true}); 
  }
}

window.addEventListener("load", function(){
  if(section_settings.show_satisfaction_msg){
    const satisfactionModal = document.getElementById("guarantee-msg-modal-wrapper");
    const satisfactionGrntBtn = document.getElementById("guarangee-msg-el")
    const satisfactionCloseModalBtn = document.getElementById("gurantee-msg-close-modal");
    satisfactionGrntBtn.addEventListener("click", (e) => {
      toggleModalOnClick(satisfactionModal, e)
    });
    satisfactionCloseModalBtn.addEventListener("click", (e) => {
      toggleModalOnClick(satisfactionModal, e)
    })
  }
})